<template>

    <div class="feedback-wrapper">
      <div id="feedback" class="feedback">
        <div class="feedback__bg"></div>
        <div class="container">
          <div class="feedback__content">
            <div class="subtitle">
              {{ $t('uniqueExperience') }}
            </div>
            <div class="title">{{ $t('feedbackUsers') }}</div>
            <LazyVideoSlider :items="cardArray" v-if="isVisibleSection"/>
          </div>
        </div>
      </div>
    </div>

</template>

<script setup lang="ts">
import {
  LazyVideoComponentOfferVideoPeople1,
  LazyVideoComponentOfferVideoPeople2,
  LazyVideoComponentOfferVideoPeople3,
  LazyVideoComponentOfferVideoPeople4,
  LazyVideoComponentOfferVideoPeople5,
  LazyVideoComponentOfferVideoPeople6,
  LazyVideoComponentOfferVideoPeople7,
  LazyVideoComponentOfferVideoPeople8,
  LazyVideoComponentOfferVideoPeople9,
  LazyVideoComponentOfferVideoPeople10,
  LazyVideoComponentOfferVideoPeople11,
  LazyVideoComponentOfferVideoPeople12,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution1,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution2,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution3,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution4,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution5,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution6,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution7,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution8,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution9,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution10,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution11,
  LazyModulesOfferImagePosterVideoEmoutionsEmoution12,
} from '#components';

const isVisibleSection = ref(false);
const cardArray = computed(() => {
  return [
    {
      id: 1,
      videoSrc: LazyVideoComponentOfferVideoPeople1,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution1,
      title: 'emotionOne',
      subtitle: 'emotionOneDesc',
      grade: 5,
    },
    {
      id: 2,
      videoSrc: LazyVideoComponentOfferVideoPeople6,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution6,
      title: 'emotionSix',
      subtitle: 'emotionSixDesc',
      grade: 5,
    },
    {
      id: 3,
      videoSrc: LazyVideoComponentOfferVideoPeople3,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution3,
      title: 'emotionThree',
      subtitle: 'emotionThreeDesc',
      grade: 4.5,
    },
    {
      id: 4,
      videoSrc: LazyVideoComponentOfferVideoPeople4,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution4,
      title: 'emotionFour',
      subtitle: 'emotionFourDesc',
      grade: 5,
    },
    {
      id: 5,
      videoSrc: LazyVideoComponentOfferVideoPeople5,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution5,
      title: 'emotionFive',
      subtitle: 'emotionFiveDesc',
      grade: 5,
    },
    {
      id: 6,
      videoSrc: LazyVideoComponentOfferVideoPeople2,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution2,
      title: 'emotionTwo',
      subtitle: 'emotionTwoDesc',
      grade: 4,
    },
    {
      id: 9,
      videoSrc: LazyVideoComponentOfferVideoPeople9,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution9,
      title: 'emotionNine',
      subtitle: 'emotionNineDesc',
      grade: 5,
    },
    {
      id: 7,
      videoSrc: LazyVideoComponentOfferVideoPeople7,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution7,
      title: 'emotionSeven',
      subtitle: 'emotionSevenDesc',
      grade: 5,
    },
    {
      id: 8,
      videoSrc: LazyVideoComponentOfferVideoPeople8,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution8,
      title: 'emotionEight',
      subtitle: 'emotionEightDesc',
      grade: 4.5,
    },
    {
      id: 12,
      videoSrc: LazyVideoComponentOfferVideoPeople12,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution12,
      title: 'emotionTwelve',
      subtitle: 'emotionTwelveDesc',
      grade: 5,
    },
    {
      id: 10,
      videoSrc: LazyVideoComponentOfferVideoPeople10,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution10,
      title: 'emotionTen',
      subtitle: 'emotionTenDesc',
      grade: 4,
    },
    {
      id: 11,
      videoSrc: LazyVideoComponentOfferVideoPeople11,
      posterSrc: LazyModulesOfferImagePosterVideoEmoutionsEmoution11,
      title: 'emotionEleven',
      subtitle: 'emotionElevenDesc',
      grade: 5,
    },
  ];
});
onMounted(() => {
  isVisibleSection.value = true;
});
</script>

<style scoped lang="scss">
.feedback-wrapper {
  height: auto;
  margin: 0;
  left: 0;
  padding: 0;
  width: 100vw;
}
.feedback {
  width: 100vw;
  position: relative;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;

  .container {
    grid-row: 1/2;
    grid-column: 1/2;
  }

  &__bg {
    grid-row: 1/2;
    grid-column: 1/2;
    width: 100vw;
    height: 100%;
    z-index: -1;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.5) 0%,
        rgba(0, 0, 0, 0.5) 100%
    ),
    url($static-url + '/images/offer-section-feedback.webp'),
    lightgray 50% / cover no-repeat;
    background-position: center;
    background-size: cover;
    background-attachment: fixed;
  }

  &__content {
    height: 100%;
    width: 100%;
    padding: 96px 0px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: $mt-10;

    .video-slider {
      margin-top: $m-20;

      @media (max-width: $md) {
        margin-top: $m-10;
      }
    }

    .subtitle {
      margin-top: -$mt-10;
      @include subtitle-fs-18-fw-400-white-000;
      text-align: center;
    }

    .title {
      @include title-fs-48-fw-700-white-000;
      text-align: center;
      margin-top: $mt-6;
    }

    .slider-comments {
      margin-top: $mt-20;
    }

    @media (min-width: 2000px) {
      min-height: unset;
    }
    @media (max-width: $md) {
      margin-top: 0px;
      padding: $p-20 0px;
    }
  }
}
</style>
